module.exports = __webpack_public_path__ + "static/media/23.8f495594.jpg";